import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { CatalogProps } from '@/types'

import { getCatalog } from '@/lib/catalog'
import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { CtaSection } from '@/components/landing/cta-section'
import { ExtrasSection } from '@/components/landing/extras-section'
import { FaqSection } from '@/components/landing/faq-section'
import { HeroSection } from '@/components/landing/hero-section'
import { HighlightsStrip } from '@/components/landing/highlights-strip'
import { PackagesSection } from '@/components/landing/packages-section'
import { ProcessSection } from '@/components/landing/process-section'
import { ReviewsSection } from '@/components/landing/reviews-section'
import { VisitSection } from '@/components/landing/visit-section'
import { WhySection } from '@/components/landing/why-section'
import { siteConfig } from '@/constants/site'

const Home: FC<CatalogProps> = ({ packages, extras }): ReactNode => {
    return (
        <Layout>
            <Seo ogImage={siteConfig.ogImage} />

            <HeroSection packages={packages} />
            <HighlightsStrip />
            <PackagesSection packages={packages} />
            <ExtrasSection extras={extras} />
            <ProcessSection />
            <WhySection />
            <ReviewsSection />
            <FaqSection />
            <VisitSection />
            <CtaSection />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<CatalogProps> = async () => {
    try {
        return { props: await getCatalog(), revalidate: 60 }
    }

    catch (error) {
        console.error('Could not load packages and add-ons:', error instanceof Error ? error.message : error)

        return { props: { packages: [], extras: [] }, revalidate: 30 }
    }
}

export default Home
